<template lang="pug">
.container.is-fluid
    .columns
        .column.is-narrow
            p.title.t-1 Profile
    .columns.is-centered
        .column.is-one-fifth
            figure.image.is-3by3
                img.circular-image(src="@/assets/images/carson_bard.png")
            p.title.has-text-weight-light.t-1 Carson Bard
            p.subtitle.has-text-weight-light.t-1 Junior
            p.subtitle.has-text-weight-light.t-1 This is my bio!
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";

export default {
  name: "Profile",
  title: "Profile",
  components: {
    Sidebar
  }
};
</script>
